import { IUser } from '../services/users';

export enum Profile {
  ADMIN = 'admin',
  CUSTOMER = 'customer',
  CONSULTANT = 'consultant',
}

export const isAdmin = (user: IUser) => {
  return user.profile?.route === Profile.ADMIN;
};

export const isCustomer = (user: IUser) => {
  return user.profile?.route === Profile.CUSTOMER;
};

export const isConsultant = (user: IUser) => {
  return user.profile?.route === Profile.CONSULTANT;
};

/** Destino padrão após login ou clique no logo. */
export const getDefaultHomePath = (user: IUser | null | undefined): string => {
  if (!user) return '/';
  if (isAdmin(user)) return '/admin';
  if (isConsultant(user)) return '/consultant/dashboard';
  return '/dashboard/summary';
};
